module.exports = __webpack_public_path__ + "fonts/Inter-Medium.eea97ded.woff2";